export const TEMPLATE_TYPE_DELEGATION = 'MemberDelegation'
export const TEMPLATE_TYPE_SIMPLE = 'Simple'
export const TEMPLATE_TYPE_XSLT = 'XsltXmlMessage'
export const TEMPLATE_TYPE_VALUES = [TEMPLATE_TYPE_DELEGATION, TEMPLATE_TYPE_SIMPLE, TEMPLATE_TYPE_XSLT]
export const TEMPLATE_TYPE_DEFAULT_VALUE = TEMPLATE_TYPE_SIMPLE
